import { ComponentProps, FC, ReactNode, useState } from "react";
import { Flex, Switch } from "@payping/web-components";

type SwitchProps = ComponentProps<typeof Switch>;

interface SwitchRowProps extends SwitchProps {
  label?: ReactNode;
}

export const SwitchRow: FC<SwitchRowProps> = ({ label, checked, onChange, disabled, ...props }: SwitchRowProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked || false);

  return (
    <Flex
      align="center"
      className="tw:w-full"
      gap={"small"}
      onClick={(event: any) => {
        if (!disabled) {
          onChange?.(!isChecked, event);
          setIsChecked(!isChecked);
        }
      }}
    >
      {label}
      <Switch onChange={label ? undefined : onChange} checked={isChecked} disabled={disabled} {...props} />
    </Flex>
  );
};

SwitchRow.displayName = "SwitchRow";
